import styled from '@emotion/styled'

export const ShadowPlaceholder = styled.div`
  border-radius: 9.64px;
  box-shadow: 1.2px 1.2px 8.43px 0px #00000024 inset;
  padding: 12.05px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 53px;
  width: 53px;
`
